import { createSelector } from 'reselect';
import { welcomeMatSelector } from 'ai/selectors/testTarget/welcomeMat/welcomeMatSelector';

const showSelector = createSelector(welcomeMatSelector, welcomeMat => !!welcomeMat.show);

export { showSelector };
